module.exports = __webpack_public_path__ + "img/Couple.416a06f4.svg";